package com.evoapps.evoshift.data.dto.auth

import kotlinx.serialization.Serializable

@Serializable
data class DeviceDto(
    val token: String,
    val platform: String,
    val lastActiveAt: String,
    val deviceName: String,
    /** The app's language on the device: the server's push language (SH-109). */
    val language: String? = null
)
